import { useState } from 'react';
import { Button, Input, Modal, message } from 'antd';
import { posService } from '@/services/pos.service';
import { mapDetailToPosVariant } from '../utils/mapVariantDetail';
import type { PosVariant, FulfillmentMode } from '../types';

interface Props {
  fulfillmentMode: FulfillmentMode;
  onVariantsFound: (variants: PosVariant[]) => void;
}

export function BulkQrModalButton({ fulfillmentMode, onVariantsFound }: Props) {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(false);

  const handleImport = async () => {
    const codes = text
      .split('\n')
      .map((s) => s.trim())
      .filter(Boolean);
    if (codes.length === 0) return;
    setLoading(true);
    try {
      const { items, item_errors } = await posService.lookupVariants(codes, fulfillmentMode);
      const variants = items.map(mapDetailToPosVariant);
      onVariantsFound(variants);
      if (item_errors.length > 0) {
        void message.error(
          `${item_errors.length} mã không thêm được: ${item_errors.map((e) => e.qr_code).join(', ')}`,
        );
      }
      if (variants.length > 0) {
        void message.success(`Đã thêm ${variants.length} sản phẩm`);
        setOpen(false);
        setText('');
      }
    } catch {
      void message.error('Lỗi nhập danh sách');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button onClick={() => setOpen(true)}>Nhập DS</Button>
      <Modal
        title="Nhập danh sách QR"
        open={open}
        onOk={() => void handleImport()}
        onCancel={() => setOpen(false)}
        confirmLoading={loading}
        okText="Thêm vào đơn"
      >
        <Input.TextArea
          rows={6}
          placeholder="Mỗi dòng 1 mã QR"
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
      </Modal>
    </>
  );
}
